import { Component, OnInit, OnDestroy } from '@angular/core';
import { DhhpAlertComponent } from '../../shared/dhhpalert/dhhpalert.component';
import { ApiService } from 'profile';
import { environment } from '../../../environments/environment';
import { LayoutService } from '../services/layout.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit ,OnDestroy {
  userprinciplename;
  clientId;
  clientSecret;
  logOutUrl:string;
  constructor(
    private profileApiService:ApiService,
    private dhhpAlert: DhhpAlertComponent, 
    private dataService: LayoutService) { }

  ngOnInit() {
    this.dataService.changeExpandValue(false);
    this.dataService.mainMenuView.next(true);
    this.profileApiService.apiUrl = environment.PLATFORM_AUTH;
    this.profileApiService.tokenKey = environment.loginAccesstok;
    this.clientId = environment.ClientId;
    this.clientSecret = environment.ClientSecret;
    this.logOutUrl = environment.Platform_URI;
    this.userprinciplename = localStorage.getItem('user_token');
  }
  onDataEvent(event){
    switch(event.event){
      case 'success': this.dhhpAlert.dhhpAlertConfirmation('Success, Activation code sent to your email', '');break;
      case 'failure': this.dhhpAlert.dhhpAlertError('Error when resetting password', '');break;
      case 'changePasswordSuccess': this.dhhpAlert.dhhpAlertConfirmation('Password updated Successfully', '');break;
      case 'changePasswordFailure': this.dhhpAlert.dhhpAlertError('Please enter valid password', '');break;
      case 'deleteAccount': this.dhhpAlert.dhhpAlertConfirmation('OTP sent successfully', '');break;
      case 'profileUpdateError': this.dhhpAlert.dhhpAlertError(event.value, '');break;
      case 'profileUpdateSuccess': this.dhhpAlert.dhhpAlertConfirmation('Profile details updated successfully', '');break;
      case 'consentUpdates': this.dhhpAlert.dhhpAlertConfirmation('Consent updated successfully', '');break;
      case 'suceessDel': this.dhhpAlert.dhhpAlertConfirmation('Delete request sent successfully', '');break;
      case 'failureDel': this.dhhpAlert.dhhpAlertConfirmation('Wrong or expired OTP, Please re-enter', '');break;
      case 'error': this.dhhpAlert.dhhpAlertError(event.message, '');break;
    }
  }

  ngOnDestroy(){
    this.dataService.changeExpandValue(true);
    this.dataService.mainMenuView.next(false);
  }
 
} 
